export const openNewWindow = (url) => {
	window.open(url, undefined, 'width=600,height=600');
};

export const getPagePath = () => {
	const url = window.location.href;
	const index = url.lastIndexOf('?');

	return url.slice(0, index);
};
